import instObj from '@/backend/axios-instances'

const resource = "/workstation"
const instance = instObj.baseInstance

export default {
  get(workstationId, parameters) {
    return instance.get(`${resource}/${workstationId}`, { params: parameters });
  },
  put(workstationId, data, parameters) {
    return instance.put(`${resource}/${workstationId}`, data, { params: parameters });
  },
  delete(workstationId) {
    return instance.delete(`${resource}/${workstationId}`);
  }
}
